import { CartStore } from "./data/CartStore.js";
import { SubstitutionRootStore } from "./data/SubstitutionProducts/SubstitutionRootStore.js";
import { ComparatorStore } from "./data/ComparatorStore.js";
import OptionsStore from "./config/OptionsStore.js";
import { UiStore } from "./ui/UiStore.js";
import { ConfirmStore } from "./ui/ConfirmStore.js";
import { LabelsStore } from "./config/LabelsStore.js";
import { RelatedRootStore } from "./data/RelatedProducts/RelatedRootStore.js";
import { AlterationsStore } from "./data/AlterationsStore.js";
import { SubstitutionProductsAPI } from "../services/SubstitutionProductsAPI.js";
import { Notificator } from "../helpers/Notficator.js";
import { getMyProductsAPI } from "../services/MyProductsAPI.js";
import { ComparatorAPI } from "../services/ComparatorAPI.js";
import { DocumentsAPI } from "../services/DocumentsAPI.js";
import { DocumentsStore } from "./data/DocumentsStore.js";

/** @typedef {import('../../services/myProductsApi').ProductsGroup} ProductsGroup */

/**
 *  @typedef {object} localeObj
 *  @property {string} countryCode
 *  @property {string} languageCode
 */

/**
 * @typedef {object} StoresData
 * @property {import('./config/OptionsStore').CartSettings} initialSettings
 * @property {ProductsGroup[]} productGroups
 * @property {object} labelsObj
 * @property {object} localeObj
 * @property {HTMLElement} appMountPoint
 * @property {boolean} isPublic
 * @property {object} selectorConfiguration
 */
export class RootStore {
  services = {};

  helpers = {};

  /** @param {StoresData} storesData */
  constructor(storesData) {
    this.localeObj = storesData.localeObj;
    this.isPublic = storesData.isPublic;
    this.initServices();
    this.initHelpers(storesData.labelsObj, storesData.appMountPoint);
    this.initStores(storesData);
  }

  initServices = () => {
    this.services.comparatorAPI = new ComparatorAPI();
    this.services.myProductsAPI = getMyProductsAPI(this.localeObj);
    this.services.substProductsAPI = new SubstitutionProductsAPI(
      this.localeObj
    );
    this.services.documentsAPI = new DocumentsAPI(this.localeObj);
  };

  initHelpers = (labelsObj, appMountPoint) => {
    this.helpers.notificator = new Notificator(labelsObj, appMountPoint);
  };

  /**
   * @param {StoresData} storesData
   */
  initStores = ({ initialSettings, productGroups, labelsObj, localeObj, selectorConfiguration }) => {
    // Stores create order matters!
    this.alterationsStore = new AlterationsStore(this);
    this.comparatorStore = new ComparatorStore(this);
    this.optionsStore = new OptionsStore(initialSettings, this);
    this.labelsStore = new LabelsStore(labelsObj);
    this.uiStore = new UiStore(this, selectorConfiguration);
    this.cartStore = new CartStore(productGroups, this);
    this.confirmStore = new ConfirmStore(this);
    this.relatedRootStore = new RelatedRootStore(localeObj, this);
    this.substRootStore = this.optionsStore.disableSubstitutions
      ? null
      : new SubstitutionRootStore(productGroups, this);
    this.documentsStore = new DocumentsStore(this);
    
  };
}
